import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizBanner from "../../../../styles/img/quiz-banner.png";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBaner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import Footer from "../../components/footer/Footer";
import { UiBlueBox } from "../../../_uiComponents/common/UiBlueBox";
import { Button } from "react-bootstrap";
import { QuestionLinks } from "../../../_uiComponents/common/QuestionLinks";
import { CircleTick } from "../../../../styles/img/svg/CircleTick";
import { UiQuestionWrapper } from "../../../_uiComponents/common/UiQuestionWrapper";
import { NeedAHelp } from "./Views/NeedAHelp";
import deviderImage from '../../../../styles/img/knowledge-progress.jpg';


export const TemplateSectionDividerWithImage = (props) => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBaner
                    title="Volvo 4x4 Programme"
                    description="Let’s sharpen up your knowledge with fast informative quiz!"
                    sliderCardImage={quizBanner}
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="   Volvo 4x4 Quiz"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-mcq-template-page">
                        <UiContentCol>
                            <UiSingleRow>
                                <UiCol lg="3" className="sb-img-q-template-page__links">

                                    <UiBlueBox >
                                        <p>Questions Remaining</p>
                                        <h3>10/15</h3>
                                    </UiBlueBox>

                                    <QuestionLinks className="sb-green-links">
                                        <li className="active"><a href="#"> <CircleTick /> My Progress</a></li>
                                        <li><a href="#"><CircleTick />  Introduction</a></li>
                                        <li><a href="#"><CircleTick />  Introduction Section 2</a></li>
                                        <li><a href="#"><CircleTick />  Section 3</a></li>
                                        <li><a href="#"><CircleTick />  Section 4</a></li>
                                        <li><a href="#"><CircleTick />  Section 5</a></li>
                                    </QuestionLinks>


                                </UiCol>
                                <UiCol lg="9" className="sb-img-q-template-page__content">
                                    <UiQuestionWrapper>
                                        <div className="sb-temp-devider-content">
                                            <h3><span> Section Title </span>  </h3>
                                            <UiSingleRow>
                                                <UiCol lg="5">
                                                    <h3 className="sb-mt-2">
                                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</h3>
                                                </UiCol>
                                                <UiCol lg="7" className="sb-temp-devider-content__image">
                                                <div></div>
                                                    <img src={deviderImage} />
                                                    
                                                </UiCol>
                                            </UiSingleRow>
                                        </div>

                                        <Button >Next?</Button>
                                    </UiQuestionWrapper>

                                </UiCol>
                            </UiSingleRow>
                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <NeedAHelp />

                <Footer />

            </UiMainWrapper>

        </>
    )
}